import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/apt/[id]/error.tsx");
